import { KibCareTeamIcon } from '@chewy/kib-icons-react';
import { KibReceiptIcon } from '@chewy/kib-icons-react';
import { KibAutoshipMonoIcon } from '@chewy/kib-icons-react';
import { KibAccountCircleIcon } from '@chewy/kib-icons-react';
import { UserActionType } from '../types';
/**
 * Maps payload action strings to Chirp icons. Use only icons that are exported
 * from `@chewy/kib-icons-react` for your pinned version — named imports that do
 * not exist resolve to `undefined` and will crash at runtime when rendered.
 */
export const getIconByActionType = (actionType: string) => {
    if (!actionType) {
        return undefined;
    }

    switch (actionType) {
        case UserActionType.CONTACT_CARE_TEAM:
        case UserActionType.CONNECT_TO_AGENT:
            return <KibCareTeamIcon />;
        case UserActionType.VIEW_ORDER:
        case UserActionType.ORDER_HELP:
            return <KibReceiptIcon />;
        case UserActionType.VIEW_AUTOSHIP:
        case UserActionType.AUTOSHIP:
            return <KibAutoshipMonoIcon />;
        case UserActionType.VIEW_ACCOUNT:
        case UserActionType.MANAGE_ACCOUNT:
            return <KibAccountCircleIcon />;
        default:
            return undefined;
    }
};
